import { __decorate, __metadata } from 'tslib';
import React, { Component } from 'react';
import Badge from '@tencent/dui/lib/components/Badge';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { EnvContext } from '../../controllers/workbench/context.js';
import { setActionPointEvent } from '../../providers/action-point/action-point-runner.js';
import { MenuService } from '../../services/menu/menu-service.js';
import { BuiltinUiState } from '../../services/store/builtin-state.js';
import { withState } from '../../services/store/with-state.js';
import { MainMenuDropdown } from './main-menu-dropdown.js';
import styles from './menu.less.js';
import { Inject } from '@tencent/ioc';
import { IBadgeService } from '../../services/badge/badge-service.interface.js';
import { AccessibilityKeyDownType, AccessibilityKeyCodes } from '../../constants/accessibility-operation-type.js';
import { WorkbenchSettingsService } from '../../services/settings/setting-service.js';

class MainMenuComponent extends Component {
    constructor() {
        super(...arguments);
        this.dropdownRef = React.createRef();
        this.state = {
            active: false,
            hideDropdown: false,
            isExpanded: false,
            alignment: this.initAlignment(this.props.align),
        };
        this.handleMenuClick = (id, event) => {
            var _a;
            const config = this.menuService.getConfigByPath(id);
            setActionPointEvent(config === null || config === void 0 ? void 0 : config.onClick, event);
            (_a = config === null || config === void 0 ? void 0 : config.onClick) === null || _a === void 0 ? void 0 : _a.call(config);
            if (this.props.badge.some(info => info.key === (config === null || config === void 0 ? void 0 : config.name) && info.position === 'menu')) {
                this.badgeService.removeBadgeOn('menu', config.name);
            }
        };
        this.shouldHideDropdown = (value) => {
            this.setState({ hideDropdown: value });
        };
        this.handleClick = (event) => {
            var _a, _b;
            (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        };
        /** 处理menu键盘事件，支持无障碍操作，操作按键属于ENTER则触发click事件 */
        this.handleKeyDown = (event) => {
            var _a;
            const accessibilityKeyCodeOperation = {
                [AccessibilityKeyDownType.ENTER]: () => {
                    var _a, _b;
                    (_b = (_a = event.target).click) === null || _b === void 0 ? void 0 : _b.call(_a);
                    /** 更新当前menuitem是否展开状态 */
                    this.setState({ isExpanded: !this.state.isExpanded });
                },
            };
            const accessibilityKeyCodeMap = new Map();
            Object.keys(AccessibilityKeyCodes).forEach((key) => {
                accessibilityKeyCodeMap.set(key, accessibilityKeyCodeOperation[AccessibilityKeyCodes[key]]);
            });
            const { keyCode } = event;
            (_a = accessibilityKeyCodeMap.get(keyCode.toString())) === null || _a === void 0 ? void 0 : _a();
        };
        this.handleMouseEnter = (event) => {
            var _a, _b;
            (_b = (_a = this.props).onMouseEnter) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        };
        this.handleMouseLeave = (event) => {
            var _a, _b;
            (_b = (_a = this.props).onMouseLeave) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        };
        this.changeAlignment = (visible) => {
        };
        this.handleVisibleChange = (value, children) => {
            var _a, _b, _c, _d;
            if (!value) {
                (_b = (_a = this.props).onDropdownClose) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.name);
            }
            else {
                this.setState({ hideDropdown: false });
                (_d = (_c = this.props).onDropdownOpen) === null || _d === void 0 ? void 0 : _d.call(_c, this.props.name);
                if (this.props.badge.some(info => info.key === this.props.name && info.position === 'menu')) {
                    this.badgeService.removeBadgeOn('menu', this.props.name);
                }
                children.forEach((child) => {
                    var _a;
                    (_a = child.onShow) === null || _a === void 0 ? void 0 : _a.call(child);
                });
            }
            this.setState({ active: value }, () => window.requestAnimationFrame(() => {
                this.changeAlignment(value);
            }));
        };
        this.getBadgeTree = () => this.props.badge
            .filter(info => info.position === 'menu')
            .map(info => info.key);
        this.preventDismiss = (e) => {
            const selectors = this.menuService.preventDismissSelectors;
            let hit = false;
            selectors.forEach(([name, selector]) => {
                var _a;
                hit = hit || !!(this.menuService.path(name, this.props.name).length > 0
                    && ((_a = e.target) === null || _a === void 0 ? void 0 : _a.closest(selector)));
            });
            return !hit;
        };
    }
    initAlignment(alignment) {
        // if (alignment === 'left-prefer') {
        //     return 'left';
        // } if (alignment === 'right-prefer') {
        //     return 'right';
        // }
        return alignment;
    }
    searchInMenu(menu, key) {
        if (menu.children.length === 0) {
            return null;
        }
        const found = menu.children.find(child => child.name === key);
        if (found) {
            return found;
        }
        for (const child of menu.children) {
            const target = this.searchInMenu(child, key);
            if (target)
                return target;
        }
        return null;
    }
    render() {
        var _a;
        const { name, style, dropContentStyle, menu: dropdowns, animated = true, mode = 'dropdown-menu', itemStyle, dropdownContentStyle, placement = 'bottom', ariaLabel, role, } = this.props;
        const category = this.searchInMenu(dropdowns, name);
        if (!category || category.children.length === 0)
            return null;
        const badgeTree = this.getBadgeTree();
        const content = React.createElement(MainMenuDropdown, { menu: category.children, onMenuClick: this.handleMenuClick, shouldHideDropdown: this.shouldHideDropdown, key: `mainmenu-dropdown-${name}`, badgeTree: badgeTree, id: name, itemStyle: itemStyle, dropdownContentStyle: dropdownContentStyle });
        if (mode === 'menu')
            return content;
        let { active } = this.state;
        const { hideDropdown } = this.state;
        if (hideDropdown) {
            active = false;
        }
        else if (this.props.show !== undefined) {
            active = this.props.show;
        }
        return React.createElement(Dropdown, { alignment: this.state.alignment, key: category.name, dropContent: content, dropContentStyle: dropContentStyle, style: style, visible: active, animated: animated, placement: placement, onVisibleChange: visible => this.handleVisibleChange(visible, category.children), ref: this.dropdownRef, autoFocus: (_a = this.settings.accessibility) === null || _a === void 0 ? void 0 : _a.dropdownAutoFocus, shouldHide: active ? this.preventDismiss : undefined },
            React.createElement("div", { id: `main-menu-${name}`, className: `${styles['menu-button']} menu-button-${name} ${active ? styles.focus : ''}`, onClick: this.handleClick, style: this.props.contentStyle, onMouseEnter: this.handleMouseEnter, onMouseLeave: this.handleMouseLeave, onMouseDown: (event) => { event.preventDefault(); }, tabIndex: 0, role: role, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : name, "aria-expanded": this.state.isExpanded, "aria-haspopup": true, onKeyDown: this.handleKeyDown.bind(this) },
                React.createElement(Badge, { dot: badgeTree.includes(name) }, this.props.children)));
    }
}
MainMenuComponent.contextType = EnvContext;
__decorate([
    Inject(),
    __metadata("design:type", MenuService)
], MainMenuComponent.prototype, "menuService", void 0);
__decorate([
    Inject(IBadgeService),
    __metadata("design:type", Object)
], MainMenuComponent.prototype, "badgeService", void 0);
__decorate([
    Inject(),
    __metadata("design:type", WorkbenchSettingsService)
], MainMenuComponent.prototype, "settings", void 0);
/**
 * 主菜单组件
 *
 * @public
 */
const MainMenu = withState([
    BuiltinUiState.Menu,
    BuiltinUiState.Badge,
])(MainMenuComponent);

export { MainMenu };
//# sourceMappingURL=menu.js.map
